export default "__VITE_ASSET__6K1k8JNI__"